import Immutable from 'immutable';
import { confirmLexicalStateInTextComponent } from 'modules/draftjs2lexical';
import * as lexical from 'modules/Lexical/helpers/referenceCitations';
import { call, put, select } from 'redux-saga/effects';
import { addDocuments } from 'containers/Documents/actions';
import { textComponentsForAssetsPanel as textComponentsSelector } from 'containers/Documents/selectors';
import { layeredRelations } from 'containers/Relations/selectors';
import * as Models from 'models';
import { handleSagaError } from 'services/handleError';
import { getApplicableForTextCompnentFirstLayeredRelationStyles } from './utils';

export function* replaceReferenceCitationWithinComponents(
  componentIds: Immutable.List<string>,
  oldReferenceId: string,
  newReferenceId: string,
): Generator {
  try {
    const relations = (yield select(layeredRelations)) as ReturnType<typeof layeredRelations>;

    const textComponents = (yield select(textComponentsSelector)) as ReturnType<typeof textComponentsSelector>;
    const textComponentsToUpdate = textComponents.filter(component => Boolean(
      component
      && componentIds.includes(component.get('id'))
      && component.get('referenceCitations').includes(oldReferenceId),
    ));

    const updatedComponents = textComponentsToUpdate.map((component: Models.TextComponentMap) => {
      const componentToUpdate = confirmLexicalStateInTextComponent(
        component,
        getApplicableForTextCompnentFirstLayeredRelationStyles(component.get('id'), relations),
      );

      return lexical.replaceReferenceCitationIdOnComponent(componentToUpdate, oldReferenceId, newReferenceId);
    });

    // TODO: just return results instead of updating store
    yield put(addDocuments(updatedComponents as Models.TextComponentsMap));
  } catch (error) {
    yield call(handleSagaError, error, 'ArtboardCell.replaceReferenceCitationsWithinComponents', 'ReplaceReferenceCitations');
  }
}
